const SelectPlanButton = ({ onClick, label }) => {
  return (
    <div className="d-flex justify-content-center">
      <button
        type="button"
        className={`saveEditTenantButton sub_text fw-500 white`}
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  );
};

export default SelectPlanButton;
